const ModalTitle = ({ title }) => {
  return (
    <div className="modal-header">
      <div className="modal-title-container">
        <span className="modal-title">{title}</span>
      </div>
    </div>
  );
};

export default ModalTitle;
